import { TextField } from "@mui/material";
import styled from "styled-components";

export const CustomInputField = styled(TextField)`
  width: 100%;
  white-space: pre-line;
`;
